import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
// import ModalConvocatoria from '../Modal/ModalConvocatoria';

  
const Inicio = () => {
  
  // const [isModalOpen, setModalOpen] = useState(true);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



 /*  const closeModal = () => {
    setModalOpen(false);
  }; */
 

  return (
    <>
      <Carousel />
      <div className='container'>
        <div className='row'>
          <div className='secretaria_logo' >
            <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Oficialia.svg")` }}>
            </div>
          </div>
          <div className='secretaria_name'>
            <h1>OFICIALÍA MAYOR</h1>
          </div>
          <div className='secretaria_funciones'>

           
            <h3 className='title'>ATRIBUCIONES</h3>
            <hr className='hr-gob' />
            <p>La Oficialía Mayor del Estado de Hidalgo tiene dentro de sus atribuciones lo siguiente:</p>

            <div id="global">
              <div id="mensajes">
                <div class="texto">
                   I.- Aplicar y dar seguimiento a las políticas y medidas de austeridad, racionalidad, optimización, contención y eficacia del gasto público en el ámbito de su competencia;
                   <br>
                   </br>II.- Determinar la administración de los recursos técnicos y materiales, así como los servicios y gastos necesarios del Poder Ejecutivo del Estado, a partir de su debida planeación, ejecución y seguimiento, en sujeción a las medidas establecidas en materia de austeridad, racionalidad, optimización, rendición de cuentas y eficacia del gasto público, atendiendo los acuerdos del Plan Estatal de Desarrollo; 
                  <br>
                  </br>III.- Administrar, normar, controlar y vigilar los recursos humanos de las Dependencias y Entidades de la Administración Pública Estatal, bajo directrices que promuevan el buen funcionamiento de las estructuras orgánicas atendiendo el ámbito de su competencia, mediante su participación y suscripción en los actos jurídicos necesarios para tal efecto; 
                  <br>
                  </br>IV.- Validar y actualizar las estructuras orgánicas y administrativas de las Dependencias y entidades de la Administración Pública Estatal; así como sus manuales de organización y de procedimientos, a través de mecanismos de colaboración y asistencia técnica; 
                  <br>
                  </br>V.- Normar, organizar, coordinar y ejecutar el sistema de contratación y adquisiciones de bienes, servicios y arrendamientos de bienes muebles e inmuebles que se requieran para el funcionamiento del Poder Ejecutivo del Estado, así como celebrar en coordinación con las Dependencias y Entidades de la Administración Pública, los contratos y convenios necesarios de acuerdo a la normatividad establecida; 
                  <br>
                  </br>VI.- Determinar, normar y ejecutar las políticas, bases y lineamientos en materia de recursos humanos, a partir de su contratación y movimientos de personal, así como lo relativo a licencias, préstamos, pensiones, jubilaciones y compensaciones por retiro, que deberán observar las personas servidoras públicas de las Dependencias y Entidades del Poder Ejecutivo del Estado; 
                  <br>
                  </br>VII.- Normar, organizar y coordinar el esquema escalafonario aplicable a las personas servidoras públicas de base del Poder Ejecutivo del Estado; 
                  <br>
                  </br>VIII.- Dictar los lineamientos para el ejercicio del dominio, posesión, administración, conservación, vigilancia y acondicionamiento de los bienes que conforman el patrimonio del Poder Ejecutivo del Estado de Hidalgo, suscribiendo los actos jurídicos necesarios para tal efecto; 
                  <br>
                  </br>IX.- Determinar las políticas y mecanismos para ejercer actos traslativos de dominio, de adquisición, posesión, inspección y vigilancia sobre el patrimonio del Estado, de conformidad con lo que establecen los ordenamientos legales vigentes; 
                  <br>
                  </br>X.- Regular la administración de los bienes muebles e inmuebles, servicios generales y de los almacenes generales del Poder Ejecutivo del Estado; 
                  <br>
                  </br>XI.- Actuar como depositario respecto de los bienes susceptibles de ser transferidos al Poder Ejecutivo del Estado bajo cualquier título; 
                  <br>
                  </br>XII.- Ejercer el derecho de reversión sobre los bienes, en sujeción a las disposiciones aplicables; 
                  <br>
                  </br>XIII.- Formular, integrar e instrumentar las políticas, bases, lineamientos y demás disposiciones normativas conferidas en el ámbito de su competencia, para el pleno ejercicio de sus atribuciones; 
                  <br>
                  </br>XIV.- Estipular los mecanismos para ejercer actos de dominio, inspección y vigilancia sobre el patrimonio del Estado, de conformidad con lo que establecen los ordenamientos legales vigentes; y señalar las políticas para ejercer el derecho de reversión sobre los bienes otorgados con la intervención de las Dependencias competentes, salvo en los casos en que la Ley de la materia lo faculte para hacerlo directamente; 
                  <br>
                  </br>XV.- Elaborar y emitir de manera conjunta con la Secretaría de Hacienda, la Secretaría de Contraloría y la Unidad de Planeación y Prospectiva, las políticas y medidas de austeridad, racionalidad y optimización presupuestal que deberán de observar las Dependencias y Entidades del Poder Ejecutivo del Estado en el ejercicio del gasto público, para las acciones de gobierno que determine la Persona Titular del Poder Ejecutivo del Estado a través de la Comisión Intersecretarial de Gasto Público y Financiamiento; 
                  <br>
                  </br>XVI.- Implementar, aplicar y dar seguimiento al sistema de capacitación y profesionalización de las personas servidoras públicas de las Dependencias y Entidades del Poder Ejecutivo del Estado, en coordinación con la Secretaría de Contraloría y la Secretaría del Despacho de la Persona Titular del Poder Ejecutivo del Estado, a través de la Academia para la Transformación; 
                  <br>
                  </br>XVII.- Controlar y administrar las partidas centralizadas del Poder Ejecutivo del Estado en apego al marco normativo vigente, coadyuvando en el uso racional de los recursos públicos; 
                  <br>
                  </br>XVIII.- Coordinar, promover y ejecutar las políticas y estrategias de innovación y modernización gubernamental, para consolidar un Gobierno Digital, mediante el máximo aprovechamiento de las tecnologías de la información y comunicación, y 
                  <br>
                  </br>XIX.- Las demás que, en relación a su competencia, le señale la Persona Titular del Poder Ejecutivo del Estado, las leyes, reglamentos, decretos, acuerdos, convenios y disposiciones vigentes en el Estado.
                </div>
              </div>
            </div>
     

            <div className='btn_organigrama'>
               <a href="/pdf/misionvision.pdf"><button type="button" class="btn btn-primary">Misión y Visión</button></a>
              <a href="/Transparencia/Rubros/DetalleRubro/1.%20Normatividad"><button type="button" class="btn btn-primary">Normatividad</button></a>
              <a href="/Transparencia/Rubros/DetalleRubro/2.%20Estructura"><button type="button" class="btn btn-primary">Organigrama</button></a>
             
            </div>
            <div className='secretaria-redes'>
              <a href='https://www.facebook.com/Oficialiamayordehidalgo/?locale=es_LA'><i class="fa-brands fa-facebook-f"></i></a>
              <a href='https://twitter.com/OficialiaMa'><i class="fa-brands fa-twitter"></i></a>
            </div>
          </div>
        </div>
        <UltimasNoticias />
        <div className='row'>
          <div className='notes_title'>
            <h3 className='title'>TITULAR DE LA OFICIALÍA MAYOR</h3>
            <hr className='hr-gob' />
          </div>
          <div className='section_notes'>
            {
              titular.map((item, index) => (
                <>
                  <div key={index} className='sec_photo'>
                    <div className='img_secretario' style={{ backgroundImage: `url("${item.imagen}")` }}>
                    </div>
                  </div>
                  <div className='sec_container'>
                    <div className='sec_name'>
                      <h3>{item.nombre}</h3>
                    </div>
                    <div className='sec_function'>
                      {/* <h4>Función del Secretario</h4> */}
                      <p>{item.funcion}</p>
                      <div className='btn_agenda'>
                        <Link to="Agenda">Conoce la agenda del Secretario</Link>
                      </div>
                    </div>
                  </div>
                </>
              ))
            }
          </div>
        </div>

        {/* <ModalConvocatoria isOpen={isModalOpen} onClose={closeModal} /> */}

        <div className='row'>
          <div className='section_map'>
            <div className='map_name'>
              <h3 className='title'>UBICACIÓN</h3>
              <hr className='hr-gob' />
            </div>
            <iframe src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=es&amp;q=palacio%20de%20gobierno%20pachuca%20hidalgo+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              width="100%"
              height="300"
              frameborder="0"
              style={{ border: 0, marginBottom: 50 }}
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </div>
    </>
  )
}

export default Inicio